import React, { Component } from "react"
import Link from 'gatsby-link'

class Nav extends Component {
  render() {

    let language = this.props.language

    return(
      <div>
        <div className="header__nav">
          <Link
            to={`/${language}`}
            className="header__nav__item"
          >
            Home
          </Link>
          <Link
            to="/it"
            className="header__nav__item"
          >
            ITA
          </Link>
          <Link
            to={`/`}
            className="header__nav__item"
          >
            ENG
          </Link>
        </div>
      </div>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/index.js